import styled from "styled-components";

export const Wrapper = styled.div`
    margin-inline-start: auto;

    @supports not (margin-inline: 0) {
        margin-left: auto;
        text-align: end;
    }
`;
